


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTCONTACTUSSECTION
// REJECTCONTACTUSSECTION


const REJECTCONTACTUSSECTION= createAsyncThunk(
  "rejectContactUsSection/rejectContactUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectContactUsSectionSlice = createSlice({
  name: "rejectContactUsSectionSlice",
  initialState: {
    rejectContactUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectContactUsSection: (state) => {
        state.rejectContactUsSection.loading = false
        state.rejectContactUsSection.error = false
        state.rejectContactUsSection.data = []
        state.rejectContactUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTCONTACTUSSECTION.fulfilled, (state, action) => {
      state.rejectContactUsSection = {
        ...state.rejectContactUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTCONTACTUSSECTION.pending, (state, action) => {
      state.rejectContactUsSection = {
        ...state.rejectContactUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTCONTACTUSSECTION.rejected, (state, action) => {
      state.rejectContactUsSection = {
        ...state.rejectContactUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectContactUsSectionAction = {
    REJECTCONTACTUSSECTION,
};

export { rejectContactUsSectionAction };
export default rejectContactUsSectionSlice.reducer;
export const {setInitialStateOfrejectContactUsSection} = rejectContactUsSectionSlice.actions
